import {useGetPublicSettings} from '@/modules/settings/api'
import {useTolgee} from '@tolgee/react'
import {useEffect} from 'react'
import {getPersistedLanguage} from '@cypro/ui/integrations/tolgee/persistence'
import {findAppropiateLanguage} from '@cypro/ui/integrations/tolgee/instance'

// syncs the app language with the global settings
export function LanguageSync() {
  const {settings} = useGetPublicSettings()
  const tolgee = useTolgee()

  useEffect(() => {
    const targetLang = findAppropiateLanguage(settings?.language) || 'en'
    const currentLang = tolgee.getLanguage()

    if (!targetLang) return
    // if user has a saved preference, no change needed
    if (getPersistedLanguage()) return

    if (targetLang !== currentLang) {
      tolgee.changeLanguage(targetLang)
    }
  }, [settings?.language, tolgee])

  return null
}
